import { removeSpacesAndEmojis } from 'utils/formatters/remove-spaces-and-emojis.util';

import { TValidatorResponse } from './types/validator-response.types';

export const isNotEmptyString = (value: string): TValidatorResponse => {
  return removeSpacesAndEmojis(value).length > 0 ? undefined : 'Cannot be empty';
};
